// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "weETH",
    token: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xbe1F842e7e0afd2c2322aae5d34bA899544b29db",
    variableDebtTokenAddress: "0x16264412CB72F0d16A446f7D928Dd0D822810048",
  },
  {
    symbol: "USDC",
    token: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x7380c583cDe4409eFF5DD3320D93a45D96B80E2e",
    variableDebtTokenAddress: "0x9355032d747f1e08F8720CD01950E652eE15cdB7",
  },
  {
    symbol: "PYUSD",
    token: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xdF7f48892244C6106EA784609f7de10AB36F9c7e",
    variableDebtTokenAddress: "0xD2cf07dEE40d3D530D15b88d689f5cd97A31FC3D",
  },
  {
    symbol: "FRAX",
    token: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x6914ECCf50837dC61b43ee478a9BD9B439648956",
    variableDebtTokenAddress: "0xfd3aDA5AAbdc6531C7C2AC46c00eBf870f5a0E6B",
  },
] as const
